import {
  Box,
  BoxProps,
  Flex,
  FlexProps,
  Icon,
  Spinner,
  Text,
  TextProps,
} from "@chakra-ui/react";
import { useEffect } from "react";
import { FaWhatsapp } from "react-icons/fa";

export interface WhatsAppContact {
  label: string;
  whatsapp?: string;
  whatsappMessage?: string;
}

export interface WhatsAppContactCardProps {
  // First entry with a whatsapp value is used for the redirect.
  // All values live in the config — nothing is hardcoded here.
  contacts?: WhatsAppContact[];
  redirectingText?: string;
  // Style props
  containerProps?: FlexProps;
  iconBoxProps?: BoxProps;
  redirectingTextProps?: TextProps;
}

function WhatsAppContactCard({
  contacts = [],
  redirectingText = "Opening WhatsApp...",
  containerProps,
  iconBoxProps,
  redirectingTextProps,
}: WhatsAppContactCardProps) {
  useEffect(() => {
    const primary = contacts.find((c) => c.whatsapp);
    if (!primary?.whatsapp) return;

    const url = `https://wa.me/${primary.whatsapp}${
      primary.whatsappMessage
        ? `?text=${encodeURIComponent(primary.whatsappMessage)}`
        : ""
    }`;

    window.location.replace(url);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Flex
      direction="column"
      align="center"
      justify="center"
      minH="60vh"
      gap="1.25rem"
      {...containerProps}
    >
      <Box {...iconBoxProps}>
        <Icon as={FaWhatsapp} boxSize="4rem" color="#25D366" />
      </Box>
      <Spinner color="#25D366" size="sm" />
      <Text fontSize="lg" fontWeight="600" {...redirectingTextProps}>
        {redirectingText}
      </Text>
    </Flex>
  );
}

export default WhatsAppContactCard;
